import React from 'react';

import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { NoAvailableMessage } from 'app/shared/components/common/NoAvailableMessage';
import PropTypes from 'prop-types';

import { currencyOptions } from 'constants/loanFee';
import { HORIZONTAL_ALIGNMENT } from 'constants/ui';
import { formatNumberToCurrencyString } from 'utils/number';

import { columnsDefs } from './ImpoundScheduleTable.constants';
import {
  footerStyles,
  tableBodyStyles,
  tableContainerStyles,
  tableHeadStyles,
  tableWrapperStyles,
} from './ImpoundScheduleTable.styles';

const ImpoundScheduleTable = ({ schedule = null, aggregateAdjustment = 0 }) => (
  <Stack sx={tableWrapperStyles}>
    <TableContainer sx={tableContainerStyles}>
      <Table>
        <TableHead sx={tableHeadStyles}>
          <TableRow>
            {columnsDefs.map(({ label, align, style }) => (
              <TableCell align={align} className="table-cell" key={label} sx={style}>
                {label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody sx={tableBodyStyles}>
          {schedule?.length ? (
            schedule.map((impound, index) => (
              <TableRow key={index}>
                {columnsDefs.map(({ id, align }) => (
                  <TableCell align={align} className="table-cell" key={id}>
                    {align === HORIZONTAL_ALIGNMENT.RIGHT
                      ? formatNumberToCurrencyString(impound?.[id] ?? 0, currencyOptions)
                      : impound?.[id]}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell align="center" className="table-cell" colSpan={6}>
                <NoAvailableMessage message="Sorry, but there is no data available for this section" />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>

    <Stack sx={footerStyles}>
      <Typography variant="medium20">Aggregate Adjustment:</Typography>
      <Typography color="primary.main" variant="medium20">
        {formatNumberToCurrencyString(aggregateAdjustment, currencyOptions)}
      </Typography>
    </Stack>
  </Stack>
);

ImpoundScheduleTable.propTypes = {
  schedule: PropTypes.array,
  aggregateAdjustment: PropTypes.number,
};

export default ImpoundScheduleTable;
